var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fill-height" },
    [
      _vm.loading_purchases || _vm.client_loading || _vm.error_loading
        ? _c(
            "v-container",
            { staticClass: "fill-height", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { justify: "center", align: "center" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _vm.error_loading
                        ? _c(
                            "div",
                            {
                              staticClass: "display-1",
                              staticStyle: { color: "gray" },
                            },
                            [_vm._v(" Не удалось загрузить закупки... ")]
                          )
                        : _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              size: "90",
                              width: "3",
                              color: "dark",
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              !_vm.products_loading &&
              _vm.products.length !== 0 &&
              !_vm.has_perm("set_order_state")
                ? [
                    _c(
                      "v-row",
                      { attrs: { justify: "center", align: "center" } },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "font-weight-medium headline pb-0 pt-10",
                            attrs: {
                              cols: "12",
                              sm: "9",
                              md: "7",
                              lg: "6",
                              xl: "5",
                            },
                          },
                          [
                            _c(
                              "v-row",
                              {
                                attrs: {
                                  justify: "space-between",
                                  align: "center",
                                  "no-gutters": "",
                                },
                              },
                              [
                                _c("v-col", { attrs: { cols: "auto" } }, [
                                  _vm._v("Новинки"),
                                ]),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "auto" } },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "text-decoration-none font-weight-regular",
                                        attrs: { to: { name: "catalog" } },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "mr-n2",
                                            attrs: {
                                              "no-gutters": "",
                                              justify: "end",
                                              align: "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "primary--text",
                                                staticStyle: {
                                                  "font-size": "14px",
                                                },
                                                attrs: { cols: "auto" },
                                              },
                                              [_vm._v(" Каталог ")]
                                            ),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "auto" } },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: { color: "primary" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.iconRight)
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      {
                        staticClass: "mb-n8",
                        attrs: { justify: "center", align: "center" },
                      },
                      [
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "9",
                              md: "7",
                              lg: "6",
                              xl: "5",
                            },
                          },
                          [
                            _c("ProductList", {
                              attrs: { products: _vm.products, row: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ product }) {
                                      return [
                                        _c("product-card", {
                                          attrs: {
                                            product: product,
                                            dense: "",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2439448467
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "v-row",
                { attrs: { justify: "center", align: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "font-weight-medium headline pb-0 pt-10",
                      attrs: { cols: "12", sm: "9", md: "7", lg: "6", xl: "5" },
                    },
                    [_vm._v(" Закупки ")]
                  ),
                ],
                1
              ),
              _vm.has_perm("add_purchase")
                ? _c(
                    "div",
                    [
                      _vm.start_add
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: { justify: "center", align: "center" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pb-1",
                                      attrs: {
                                        cols: "12",
                                        sm: "9",
                                        md: "7",
                                        lg: "6",
                                        xl: "5",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-form",
                                        {
                                          model: {
                                            value: _vm.valid,
                                            callback: function ($$v) {
                                              _vm.valid = $$v
                                            },
                                            expression: "valid",
                                          },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.rules.title,
                                              loading: _vm.add_loading,
                                              clearable: "",
                                              label: "Название для закупки",
                                              hint: "Введите название для своей закупки",
                                            },
                                            model: {
                                              value: _vm.purchase.title,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.purchase,
                                                  "title",
                                                  $$v
                                                )
                                              },
                                              expression: "purchase.title",
                                            },
                                          }),
                                          _c("v-textarea", {
                                            attrs: {
                                              rows: "2",
                                              loading: _vm.add_loading,
                                              label:
                                                "Дополнительная информация",
                                              hint: "Любой комментарий (какие-то новости и т.п.)",
                                            },
                                            model: {
                                              value: _vm.purchase.info,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.purchase,
                                                  "info",
                                                  $$v
                                                )
                                              },
                                              expression: "purchase.info",
                                            },
                                          }),
                                          _c(
                                            "v-datetime-picker",
                                            {
                                              attrs: {
                                                loading: _vm.add_loading,
                                                label: "Дата начала закупки",
                                                "date-format": "dd.MM.yyyy",
                                                "clear-text": "Очистить",
                                                "ok-text": "Готово",
                                                "date-picker-props": {
                                                  locale: "ru-ru",
                                                  firstDayOfWeek: 1,
                                                },
                                                "time-picker-props": {
                                                  locale: "ru-ru",
                                                  format: "24hr",
                                                },
                                                "text-field-props": {
                                                  rules: _vm.rules.required,
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.purchase
                                                    .buyout_date_start,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.purchase,
                                                    "buyout_date_start",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "purchase.buyout_date_start",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "dateIcon" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(_vm.icon_calendar)
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "template",
                                                { slot: "timeIcon" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(_vm.icon_clock)
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                          _c(
                                            "v-datetime-picker",
                                            {
                                              attrs: {
                                                loading: _vm.add_loading,
                                                label: "Дата окончания закупки",
                                                "date-format": "dd.MM.yyyy",
                                                "clear-text": "Очистить",
                                                "ok-text": "Готово",
                                                "date-picker-props": {
                                                  locale: "ru-ru",
                                                  firstDayOfWeek: 1,
                                                },
                                                "time-picker-props": {
                                                  locale: "ru-ru",
                                                  format: "24hr",
                                                },
                                                "text-field-props": {
                                                  rules: _vm.rules.required,
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.purchase.buyout_date_end,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.purchase,
                                                    "buyout_date_end",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "purchase.buyout_date_end",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "dateIcon" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(_vm.icon_calendar)
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "template",
                                                { slot: "timeIcon" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(_vm.icon_clock)
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                          _c(
                                            "v-datetime-picker",
                                            {
                                              attrs: {
                                                loading: _vm.add_loading,
                                                label:
                                                  "Дата начала добавления заказов",
                                                "date-format": "dd.MM.yyyy",
                                                "clear-text": "Очистить",
                                                "ok-text": "Готово",
                                                "date-picker-props": {
                                                  locale: "ru-ru",
                                                  firstDayOfWeek: 1,
                                                },
                                                "time-picker-props": {
                                                  locale: "ru-ru",
                                                  format: "24hr",
                                                },
                                                "text-field-props": {
                                                  rules: _vm.rules.required,
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.purchase.load_date_start,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.purchase,
                                                    "load_date_start",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "purchase.load_date_start",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "dateIcon" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(_vm.icon_calendar)
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "template",
                                                { slot: "timeIcon" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(_vm.icon_clock)
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                          _c(
                                            "v-datetime-picker",
                                            {
                                              attrs: {
                                                loading: _vm.add_loading,
                                                label:
                                                  "Дата окончания добавления заказов",
                                                "date-format": "dd.MM.yyyy",
                                                "clear-text": "Очистить",
                                                "ok-text": "Готово",
                                                "date-picker-props": {
                                                  locale: "ru-ru",
                                                  firstDayOfWeek: 1,
                                                },
                                                "time-picker-props": {
                                                  locale: "ru-ru",
                                                  format: "24hr",
                                                },
                                                "text-field-props": {
                                                  rules: _vm.rules.required,
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.purchase.load_date_end,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.purchase,
                                                    "load_date_end",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "purchase.load_date_end",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "dateIcon" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(_vm.icon_calendar)
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "template",
                                                { slot: "timeIcon" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(_vm.icon_clock)
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                          _c(
                                            "v-datetime-picker",
                                            {
                                              attrs: {
                                                loading: _vm.add_loading,
                                                label:
                                                  "Дата окончания оплаты заказов",
                                                "date-format": "dd.MM.yyyy",
                                                "clear-text": "Очистить",
                                                "ok-text": "Готово",
                                                "date-picker-props": {
                                                  locale: "ru-ru",
                                                  firstDayOfWeek: 1,
                                                },
                                                "time-picker-props": {
                                                  locale: "ru-ru",
                                                  format: "24hr",
                                                },
                                                "text-field-props": {
                                                  rules: _vm.rules.required,
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.purchase.pay_date_end,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.purchase,
                                                    "pay_date_end",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "purchase.pay_date_end",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "dateIcon" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(_vm.icon_calendar)
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "template",
                                                { slot: "timeIcon" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(_vm.icon_clock)
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                          _c(
                                            "v-alert",
                                            {
                                              attrs: {
                                                border: "left",
                                                type: "info",
                                                outlined: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " Вы можете включить режим дозаказа в созданной закупке, для этого нажмите у неё в правом верхнем углу "
                                              ),
                                              _c("strong", [
                                                _vm._v('"ТРИ ТОЧКИ"'),
                                              ]),
                                              _vm._v(" -> "),
                                              _c("strong", [
                                                _vm._v('"ИЗМЕНИТЬ"'),
                                              ]),
                                              _vm._v(
                                                " -> в самом низу карточки закупки есть настройка "
                                              ),
                                              _c("strong", [
                                                _vm._v("Дозаказа"),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  attrs: { justify: "center", align: "start" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-right pt-0",
                                      attrs: {
                                        cols: "12",
                                        sm: "9",
                                        md: "7",
                                        lg: "6",
                                        xl: "5",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "text-none font-weight-regular body-2 seccondary mr-2",
                                          attrs: {
                                            rounded: "",
                                            disabled: _vm.add_loading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.start_add = false
                                            },
                                          },
                                        },
                                        [_vm._v("Отмена ")]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "text-none font-weight-regular body-2 success",
                                          attrs: {
                                            rounded: "",
                                            loading: _vm.add_loading,
                                            disabled: !_vm.valid,
                                          },
                                          on: { click: _vm.onAddPurchase },
                                        },
                                        [_vm._v(" Создать ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "v-row",
                            { attrs: { justify: "center", align: "center" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-1",
                                  attrs: {
                                    cols: "12",
                                    sm: "9",
                                    md: "7",
                                    lg: "6",
                                    xl: "5",
                                  },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "text-none font-weight-regular body-2",
                                      attrs: {
                                        rounded: "",
                                        dark: "",
                                        color: "green",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.start_add = true
                                        },
                                      },
                                    },
                                    [_vm._v(" Создать новую закупку ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.purchases.length === 0
                ? _c(
                    "v-row",
                    { attrs: { justify: "center", align: "center" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "text-center text--secondary py-12",
                          attrs: {
                            cols: "12",
                            sm: "9",
                            md: "7",
                            lg: "6",
                            xl: "5",
                          },
                        },
                        [
                          _vm.has_perm("add_purchase")
                            ? _c("div", [
                                _c("div", { staticClass: "display-1" }, [
                                  _vm._v("У вас нет закупок"),
                                ]),
                                _c("div", { staticClass: "subtitle-1" }, [
                                  _vm._v(
                                    "Создайте свою первую закупку что бы начать принимать заказы"
                                  ),
                                ]),
                              ])
                            : _c("div", { staticClass: "display-1" }, [
                                _c("div", { staticClass: "display-1" }, [
                                  _vm._v("Нет доступных закупок"),
                                ]),
                                _c("div", { staticClass: "subtitle-1" }, [
                                  _vm._v("Попробуйте позже..."),
                                ]),
                              ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "infinity-load",
                        {
                          attrs: { next_page: _vm.next_page },
                          on: { loadnext: _vm.onLoadNextPurchases },
                        },
                        _vm._l(_vm.purchases, function (purchase) {
                          return _c(
                            "v-row",
                            {
                              key: purchase.id,
                              attrs: { justify: "center", align: "center" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    sm: "9",
                                    md: "7",
                                    lg: "6",
                                    xl: "5",
                                  },
                                },
                                [
                                  _c("purchase", {
                                    attrs: { purchase: purchase },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
            ],
            2
          ),
      _c("recalculation-percent-dialog"),
      _c("settings-backorder-dialog"),
      _c("download-purchase-dialog"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }